// Data types are structured as data.category.org.suffix
export const SPATIAL_LAYER_INTERSECT = 'spatial_layer_intersect';
